"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientPaymentReport = void 0;
require("./patient-payment-report.less");
require("ag-grid-community/dist/styles/ag-grid.css");
require("ag-grid-community/dist/styles/ag-theme-balham.css");
const ag_grid_react_1 = require("ag-grid-react");
const React = require("react");
const moment = require("moment-timezone");
const mobx_1 = require("mobx");
const select_1 = require("client/components/material/select");
const button_1 = require("client/components/material/button");
const patient_payment_header_1 = require("./components/patient-payment-header");
const modal_1 = require("client/components/modal");
const store_1 = require("client/modules/users/store");
const store_2 = require("client/modules/sites/modules/sites-list/store");
const date_picker_1 = require("client/components/material/date-picker/date-picker");
const mobx_react_1 = require("mobx-react");
const store_3 = require("client/modules/reporting/store");
const number_formatter_1 = require("../claim-analytics/number-formatter");
const Launch_1 = require("material-ui-icons/Launch");
const permissions_1 = require("shared/permissions");
// D-002.911
let PatientPaymentReport = class PatientPaymentReport extends React.Component {
    constructor(props) {
        super(props);
        this.showQueryManager = true;
        this.storeData = null;
        this.query = {
            start: new Date(),
            end: new Date(),
            siteId: "0"
        };
        this.CustomCellRendorIcon = (params) => {
            return (React.createElement("a", { href: `/claims/${params.value}/payment`, target: "_blank", style: { cursor: "pointer" } }, React.createElement(Launch_1.default)));
        };
        this.toUSD = (input) => {
            const options = { currency: "USD", style: "currency" };
            const decimalStr = (input / 100).toFixed(2);
            const decimalNum = Number(decimalStr);
            const usd = decimalNum.toLocaleString("en-US", options);
            return usd;
        };
        this.receiptDateTime = (date, timeZone) => {
            if (date) {
                let estMoment = moment.tz(date, "YYYYMMDDHHmmss", "America/New_York"); // date = 20250107082712 parse date into EST with moment;
                let payDateWrtSite = estMoment
                    .clone()
                    .tz(timeZone)
                    .format("hh:mm:ss A");
                ; // convert est to site timezone
                return payDateWrtSite;
            }
            return null;
        };
        this.handleSubmit = async () => {
            var _a;
            this.showQueryManager = false;
            const result = await store_3.reportsStore.loadPatinetPaymentReport({
                query: this.query
            });
            this.storeData.rowData = (_a = result === null || result === void 0 ? void 0 : result.patientPayments) !== null && _a !== void 0 ? _a : [];
        };
        this.renderQueryModal = () => {
            var _a;
            const isDev = store_1.usersStore.user.value.groupId === permissions_1.GROUPS.DEV;
            const isAdmin = store_1.usersStore.user.value.groupId === permissions_1.GROUPS.ADMIN;
            if (this.showQueryManager) {
                const cancelButton = (React.createElement(button_1.MaterialButton, { style: { marginLeft: "1em" }, onClick: () => (this.showQueryManager = false) }, "Cancel"));
                const submitButton = (React.createElement(button_1.MaterialButton, { primary: true, style: { marginLeft: "1em" }, onClick: this.handleSubmit, disabled: isDev || isAdmin ? false : this.query.siteId > "0" ? false : true }, "Submit"));
                const pharmacySelect = (React.createElement(select_1.MaterialSelect, { options: this.availableOptions, onSelect: v => {
                        mobx_1.extendObservable(this.query, { siteId: v });
                    }, label: "Pharmacy", value: (_a = this.query.siteId) !== null && _a !== void 0 ? _a : "0" }));
                const buttons = [cancelButton, submitButton];
                const model = (React.createElement(modal_1.Modal, { buttons: buttons, onCancel: () => (this.showQueryManager = false) },
                    React.createElement("div", { style: { marginLeft: "14px" } }, pharmacySelect),
                    React.createElement("div", { style: { display: "flex" } },
                        this.genDate("start"),
                        this.genDate("end"))));
                return model;
            }
        };
        this.genDate = (type) => {
            const title = type.replace(/\b\w/g, c => c.toUpperCase());
            const jsx = (React.createElement("div", { style: { padding: "1em" } },
                React.createElement("h3", null,
                    title,
                    " Date: "),
                React.createElement(date_picker_1.MaterialDatePicker, { label: `${title} Date`, required: true, value: this.query[type] || "", onChange: val => {
                        mobx_1.extendObservable(this.query, { [type]: val });
                    } }),
                React.createElement("div", { style: { display: "flex", marginTop: "1em" } },
                    React.createElement(button_1.MaterialButton, { primary: true, onClick: () => {
                            mobx_1.extendObservable(this.query, { [type]: new Date() });
                        }, style: { marginRight: "1em" } }, "Today"),
                    React.createElement(button_1.MaterialButton, { onClick: () => {
                            mobx_1.extendObservable(this.query, { [type]: null });
                        }, style: { marginRight: "1em" } }, "Clear"))));
            return jsx;
        };
        this.onButtonExport = () => {
            const params = {
                fileName: "Patient_Payment_Report.csv"
            };
            this.storeData.gridApi.exportDataAsCsv(params);
        };
        this.storeData = {
            columnDefs: [
                {
                    field: "orderId",
                    cellRendererFramework: this.CustomCellRendorIcon,
                    headerName: "Link To Payment",
                    filter: false,
                    width: 100
                },
                {
                    field: "site.displayName",
                    filter: "agTextColumnFilter",
                    headerName: "Pharmacy Name"
                },
                {
                    field: "userName",
                    filter: "agTextColumnFilter",
                    headerName: "User Who Took Payment",
                    width: 150
                },
                {
                    field: "paymentNumber",
                    filter: "agTextColumnFilter",
                    headerName: "Payment Number",
                    width: 150
                },
                {
                    field: "orderId",
                    filter: "agTextColumnFilter",
                    headerName: "Claim Number",
                    width: 130
                },
                {
                    field: "claim.rxId.rxId",
                    filter: "agTextColumnFilter",
                    headerName: "Rx #",
                    width: 110
                },
                {
                    field: "method",
                    filter: "agTextColumnFilter",
                    headerName: "Payment Method",
                    width: 150
                },
                {
                    field: "datePaid",
                    filter: "agTextColumnFilter",
                    headerName: "Payment Date",
                    width: 170
                },
                {
                    field: "timePaid",
                    filter: "agTextColumnFilter",
                    headerName: "Payment Time",
                    width: 130
                },
                {
                    field: "amountPaid",
                    filter: "agTextColumnFilter",
                    headerName: "Paid Amount",
                    width: 130
                },
                {
                    field: "refundStatus",
                    filter: "agTextColumnFilter",
                    headerName: "Refund Status",
                    width: 130
                },
                {
                    field: "checkNumber",
                    filter: "agTextColumnFilter",
                    headerName: "Check Number",
                    width: 130
                },
                {
                    field: "cardEnding",
                    filter: "agTextColumnFilter",
                    headerName: "Card Ending",
                    width: 120
                },
                {
                    field: "cardType",
                    filter: "agTextColumnFilter",
                    headerName: "Card Type",
                    width: 120
                },
                {
                    field: "cardHolderName",
                    filter: "agTextColumnFilter",
                    headerName: "Card Holder Name"
                },
                {
                    field: "transaction",
                    filter: "agTextColumnFilter",
                    headerName: "Payment Transaction Number"
                }
            ],
            defaultColDef: {
                comparator: (a, b) => typeof a === "string"
                    ? a.localeCompare(b)
                    : a > b
                        ? 1
                        : a < b
                            ? -1
                            : 0,
                enablePivot: true,
                enableRowGroup: true,
                enableValue: true,
                filter: true,
                resizable: true,
                sortable: true
            },
            floatingFilter: true,
            frameworkComponents: {
                numberFormatter: number_formatter_1.NumberFormatter
            },
            multiSortKey: "ctrl",
            rowData: []
        };
    }
    get availableOptions() {
        const options = [];
        const isDev = store_1.usersStore.user.value.groupId === permissions_1.GROUPS.DEV;
        const isAdmin = store_1.usersStore.user.value.groupId === permissions_1.GROUPS.ADMIN;
        if (isDev || isAdmin) {
            if (store_2.sitesListStore.sites.value) {
                options.push({ id: 0, label: "All Pharmacies", value: "0", highlighted: false });
                store_2.sitesListStore.sites.value.forEach((site, i) => {
                    const indexStandardizer = 1;
                    options.push({
                        id: i + indexStandardizer,
                        label: site.displayName || site.name,
                        value: site.id.toString(),
                        highlighted: false
                    });
                });
            }
        }
        else {
            const { sites } = store_1.usersStore.user.value;
            store_2.sitesListStore.sites.value.filter((site) => {
                if (sites.includes(site.id)) {
                    options.push({
                        id: site.id,
                        label: site.displayName || site.name,
                        value: site.id.toString(),
                        highlighted: false
                    });
                }
            });
        }
        return options;
    }
    formatDateToMMDDYYYY(date) {
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
        const day = String(date.getDate()).padStart(2, "0");
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
    }
    render() {
        var _a;
        const finalRowData = (_a = this.storeData.rowData) === null || _a === void 0 ? void 0 : _a.map((data) => {
            var _a;
            const netCents = (data.amountPaid || 0) - (data.refundedAmount || 0);
            return Object.assign(Object.assign({}, data), { paymentNumber: `${String(data.siteId).padStart(5, "0")}-${String(data.sitePay).padStart(5, "0")}`, amountPaid: this.toUSD(netCents), refundStatus: data.refundStatus || "", timePaid: ((_a = data.receipt) === null || _a === void 0 ? void 0 : _a.dateTime) ? this.receiptDateTime(data.receipt.dateTime, data.site.timezone)
                    : data.datePaid
                        ? moment
                            .tz(data.datePaid, data.site.timezone || "America/New_York")
                            .format("hh:mm:ss A")
                        : null, datePaid: data.datePaid
                    ? moment
                        .tz(data.datePaid, data.site.timezone || "America/New_York")
                        .format("MM-DD-YYYY")
                    : "" });
        });
        const buttons = [
            React.createElement("button", { onClick: () => {
                    this.showQueryManager = true;
                }, style: { marginLeft: "2em" }, type: "button" }, "Manage Query")
        ];
        const header = (React.createElement(patient_payment_header_1.PatientPaymentHeader, { buttons: buttons, title: "Patient Payment" }));
        const agGrid = (React.createElement("div", { className: "ag-theme-balham", style: {
                height: "85%",
                width: "100%"
            } },
            React.createElement("button", { onClick: this.onButtonExport.bind(this) }, "Export to CSV"),
            React.createElement(ag_grid_react_1.AgGridReact, { animateRows: true, columnDefs: this.storeData.columnDefs, defaultColDef: this.storeData.defaultColDef, floatingFilter: this.storeData.floatingFilter, frameworkComponents: this.storeData.frameworkComponents, groupMultiAutoColumn: true, multiSortKey: this.storeData.multiSortKey, onGridReady: params => {
                    this.storeData.gridApi = params.api;
                }, rowData: [...finalRowData], sideBar: true, suppressExcelExport: true, suppressRowClickSelection: true, pagination: true })));
        return (React.createElement(React.Fragment, null, store_1.usersStore.permissions.ReadPatientPaymentReport ? (React.createElement(React.Fragment, null,
            header,
            React.createElement("br", null),
            agGrid,
            this.renderQueryModal())) : (store_1.usersStore.showLock())));
    }
};
__decorate([
    mobx_1.observable
], PatientPaymentReport.prototype, "showQueryManager", void 0);
__decorate([
    mobx_1.observable
], PatientPaymentReport.prototype, "storeData", void 0);
__decorate([
    mobx_1.observable
], PatientPaymentReport.prototype, "query", void 0);
__decorate([
    mobx_1.computed
], PatientPaymentReport.prototype, "availableOptions", null);
PatientPaymentReport = __decorate([
    mobx_react_1.observer
], PatientPaymentReport);
exports.PatientPaymentReport = PatientPaymentReport;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/patient-payment/patient-payment-report.tsx
// module id = 3998
// module chunks = 0